import { render, staticRenderFns } from "./RelanceList.vue?vue&type=template&id=7ae41bf8"
import script from "./RelanceList.vue?vue&type=script&lang=ts"
export * from "./RelanceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports